import voucherBackToSchool from "@/assets/images/vouchers/voucher-back-to-school.png";
import voucherBirth from "@/assets/images/vouchers/voucher-birth.png";
import voucherChildrenChristmas from "@/assets/images/vouchers/voucher-children-christmas.png";
import voucherChristmas from "@/assets/images/vouchers/voucher-christmas.png";
import voucherCulture from "@/assets/images/vouchers/voucher-culture.png";
import voucherFathersDay from "@/assets/images/vouchers/voucher-fathers-day.png";
import voucherMotherDay from "@/assets/images/vouchers/voucher-mothers-day.png";
import voucherOther from "@/assets/images/vouchers/voucher-other.png";
import voucherRefund from "@/assets/images/vouchers/voucher-refund.png";
import voucherRetirement from "@/assets/images/vouchers/voucher-retirement.png";
import voucherStCatherine from "@/assets/images/vouchers/voucher-st-catherine.png";
import voucherStNicolas from "@/assets/images/vouchers/voucher-st-nicolas.png";
import voucherVacations from "@/assets/images/vouchers/voucher-vacations.png";
import voucherWedding from "@/assets/images/vouchers/voucher-wedding.png";
import type { VoucherThemes, VoucherEvent, VoucherEmployee } from "@/features/vouchers/types/voucherEmployee.type";

export const voucherThemes: VoucherThemes = {
  "Noël des enfants": {
    color: "#f43f5e73", // rose-500/45
    imgSrc: voucherChildrenChristmas,
    text: "text-rose-900 dark:text-rose-200",
    badge: "bg-rose-500/15",
    background: "bg-gradient-to-br from-rose-200/10 to-rose-500/10 rounded-lg",
  },
  "Noël des salariés": {
    color: "#ef444473", // red-500/45
    imgSrc: voucherChristmas,
    text: "text-red-900 dark:text-red-200",
    badge: "bg-red-500/15",
    background: "bg-gradient-to-br from-red-200/10 to-red-500/10 rounded-lg",
  },
  "Fête Ste Catherine": {
    color: "#22c55e73", // green-500/45
    imgSrc: voucherStCatherine,
    text: "text-green-900 dark:text-green-200",
    badge: "bg-green-500/15",
    background: "bg-gradient-to-br from-green-200/10 to-green-500/10 rounded-lg",
  },
  "Fête des Mères": {
    color: "#ec489973", // pink-500/45
    imgSrc: voucherMotherDay,
    text: "text-pink-900 dark:text-pink-200",
    badge: "bg-pink-500/15",
    background: "bg-gradient-to-br from-pink-200/10 to-pink-500/10 rounded-lg",
  },
  "Fête des Pères": {
    color: "#3b82f673", // blue-500/45
    imgSrc: voucherFathersDay,
    text: "text-blue-900 dark:text-blue-200",
    badge: "bg-blue-500/15",
    background: "bg-gradient-to-br from-blue-200/10 to-blue-500/10 rounded-lg",
  },
  "Fête St Nicolas": {
    color: "#14b8a673", // teal-500/45
    imgSrc: voucherStNicolas,
    text: "text-teal-900 dark:text-teal-200",
    badge: "bg-teal-500/15",
    background: "bg-gradient-to-br from-teal-200/10 to-teal-500/10 rounded-lg",
  },
  "Départ en Retraite": {
    color: "#10b98173", // emerald-500/45
    imgSrc: voucherRetirement,
    text: "text-emerald-900 dark:text-emerald-200",
    badge: "bg-emerald-500/15",
    background: "bg-gradient-to-br from-emerald-200/10 to-emerald-500/10 rounded-lg",
  },
  "Mariage / PACS": {
    color: "#d946ef73", // fuchsia-500/45
    imgSrc: voucherWedding,
    text: "text-fuchsia-900 dark:text-fuchsia-200",
    badge: "bg-fuchsia-500/15",
    background: "bg-gradient-to-br from-fuchsia-200/10 to-fuchsia-500/10 rounded-lg",
  },
  "Naissance": {
    color: "#8b5cf673", // violet-500/45
    imgSrc: voucherBirth,
    text: "text-violet-900 dark:text-violet-200",
    badge: "bg-violet-500/15",
    background: "bg-gradient-to-br from-violet-200/10 to-violet-500/10 rounded-lg",
  },
  "Rentrée scolaire": {
    color: "#6366f173", // indigo-500/45
    imgSrc: voucherBackToSchool,
    text: "text-indigo-900 dark:text-indigo-200",
    badge: "bg-indigo-500/15",
    background: "bg-gradient-to-br from-indigo-200/10 to-indigo-500/10 rounded-lg",
  },
  "Culture": {
    color: "#84cc1673", // lime-500/45
    imgSrc: voucherCulture,
    text: "text-lime-900 dark:text-lime-200",
    badge: "bg-lime-500/15",
    background: "bg-gradient-to-br from-lime-200/10 to-lime-500/10 rounded-lg",
  },
  "Aide aux vacances": {
    color: "#f59e0b73", // amber-500/45
    imgSrc: voucherVacations,
    text: "text-amber-900 dark:text-amber-200",
    badge: "bg-amber-500/15",
    background: "bg-gradient-to-br from-yellow-200/10 to-yellow-500/10 rounded-lg",
  },
  "Remboursement": {
    color: "#64748b73", // slate-500/45
    imgSrc: voucherRefund,
    text: "text-slate-900 dark:text-slate-200",
    badge: "bg-slate-500/15",
    background: "bg-gradient-to-br from-slate-200/10 to-slate-500/10 rounded-lg",
  },
  "Hors évènement": {
    color: "#78716c73", // stone-500/45
    imgSrc: voucherOther,
    text: "text-stone-900 dark:text-stone-200",
    badge: "bg-stone-500/15",
    background: "bg-gradient-to-br from-stone-200/10 to-stone-500/10 rounded-lg",
  },
};

export const VOUCHER_EVENTS: Record<string, VoucherEvent> = {
  NOEL_DES_ENFANTS: "Noël des enfants",
  NOEL_DES_SALARIES: "Noël des salariés",
  FETE_STE_CATHERINE: "Fête Ste Catherine",
  FETE_DES_MERES: "Fête des Mères",
  FETE_DES_PERES: "Fête des Pères",
  FETE_ST_NICOLAS: "Fête St Nicolas",
  DEPART_EN_RETRAITE: "Départ en Retraite",
  MARIAGE_PACS: "Mariage / PACS",
  NAISSANCE: "Naissance",
  RENTREE_SCOLAIRE: "Rentrée scolaire",
  CULTURE: "Culture",
  AIDE_AUX_VACANCES: "Aide aux vacances",
  REMBOURSEMENT: "Remboursement",
  HORS_EVENEMENT: "Hors évènement",
} as const;

/**
 * Returns the voucher image URL.
 * Priority: mascot_thumbnail_url from API > static image based on event
 */
export const getVoucherImageSrc = (voucher: VoucherEmployee): string => {
  if (voucher.mascot_thumbnail_url) {
    return voucher.mascot_thumbnail_url;
  }

  if (voucher.event && voucherThemes[voucher.event]) {
    return voucherThemes[voucher.event].imgSrc;
  }

  return voucherOther;
};
